module.exports = __webpack_public_path__ + "static/media/PM91.3e8ee4d6.png";